export default __webpack_public_path__ + "static/N0084-b95e6d7d5c27f94c86d7e10a04068575.png";